<template lang="pug">
.container
    nav.nav
        router-link.button__action(
            to="/product-groups/"
            active-class="null"
        )
            i.glyphicon.glyphicon-chevron-left.icon
            | Go back
        .submit__container
            div.locales
                span(
                v-if="getActiveProductGroup.localRecords.length > 1"
                ) Switching locales will clear unsaved changes.
                //- span Editing Locale:
                button.button(
                :disabled="localRecord=== getActiveLocale"
                v-for="localRecord in getSortedAvailableLocales"
                value="localRecord"
                @click="changeLocale(localRecord)"
                ) {{localRecord}}
            button.button__submit(
                type="button"
                @click="save()"
            ) Save
            button.button__action(
                @click="toggleAddLocale"
            ) Add Locale
    .editing__container
        .content__container
            h1 Edit Product Group
            .form__control-group
                label Name
                input(
                    class="input__text title"
                    type="text"
                    v-model="getActiveLocalRecord.title"
                )
            .form__control-group
                label Image URL
                input(
                    class="input__text title"
                    type="text"
                    v-model="getActiveLocalRecord.image"
                )
                img.product-image(
                    :src="getActiveLocalRecord.image"
                    v-if="getActiveLocalRecord.image"
                )
        .meta__container
            h1 &nbsp;
            .form__control-group
                label Markets
                multiselect(
                    v-model="getSortedAvailableLocales"
                    :options="getMarketsByLocale"
                    placeholder="Add a Market"
                    :multiple="true"
                )
            .form__control-group
                label Postal Codes
                vue-tags-input(
                    v-model="tag"
                    :tags="tags"
                    placeholder="Add Postal Code"
                    @tags-changed="newTags => tags = newTags"
                    :validation="postalValidation"
                    :disableAdd="false"
                )
</template>
<script>
import store from '../../store';
import VueNotifications from 'vue-notifications';
import Services from '../../services/Services';
import Multiselect from 'vue-multiselect';
import { postResource } from '../../services/Utils';
import VueTagsInput from '@johmun/vue-tags-input';
import moment from 'moment';
export default {
  name: 'ProductGroupEditor',
  components: {
    Multiselect,
    VueTagsInput
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: '',
      icon: '✅'
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: '',
      icon: '❗️'
    }
  },
  data() {
    return {
        tag: '',
      tags: [],
      postalValidation: [
        {
          classes: 'min-length',
          rule: tag => tag.text.length < 5
        },
        {
          classes: 'only-numbers',
          rule: '^[0-9]*$'
        }
      ]
    };
  },
  computed: {
    getActiveProductGroup: {
      get: function() {
        return store.getters.getActiveProductGroup;
      },
      set: function(productGroup) {
        store.commit('setActiveProductGroup', productGroup);
      }
    },
    getActiveLocale() {
      return store.getters.getActiveLocale;
    },
    getActiveLocalRecord: {
      get: function() {
        return store.getters.getActiveLocalRecord;
      },
      set: function(record) {
        store.commit('setActiveLocalRecord', record);
      }
    },
    getAllProductGroups() {
      return store.getters.getAllProductGroups;
    },
    getMarkets() {
      return store.getters.getMarkets;
    },
    getSortedAvailableLocales: {
      get: function() {
        if (
          this.getActiveProductGroup &&
          this.getActiveProductGroup.localRecords
        ) {
          let locales = [];

          this.getActiveProductGroup.localRecords.forEach(locale => {
            locales.push(locale.locale);
          });

          return locales.sort((a, b) => a.name - b.name).reverse();
        }
      },
      set: function(newLocales) {
        let activeProductGroup = { ...this.getActiveProductGroup };
        activeProductGroup.markets = newLocales;
        store.commit('setActiveProductGroup', activeProductGroup);
        if (
          activeProductGroup.localRecords &&
          newLocales.length > activeProductGroup.localRecords.length
        ) {
          store.commit('showCreateProductGroupLocalRecordModal', true);
        }
      }
    },
    getMarketsByLocale() {
      if (this.getMarkets) {
        let marketsByLocale = [];

        this.getMarkets.forEach(market => {

          marketsByLocale.push(market.locale);
        });

        return marketsByLocale;
      }
    }
  },
  methods: {
    initializeProductGroup(edited) {
      const product = this.getActiveProductGroup;

      if (!product._id) {
        this.showErrorMsg({ message: 'No matching product found' });
        this.$router.push('/products/');
      }

      // initialize default locale when we have the product record, but don't reset the active locale if we're already editing
      if (!edited) {
        if (product.fallbackLocale) {
          store.commit('setActiveLocale', product.fallbackLocale);
        } else if (product.localRecords) {
          store.commit('setActiveLocale', product.localRecords[0].locale);
        }
      }

      const activeContent =
        product.localRecords && product.localRecords.length === 1
          ? product.localRecords[0].content
          : product.localRecords.filter(record => {
              return record.locale === this.getActiveLocale;
            })[0].content || {};

      if (activeContent) {
        store.commit('setActiveLocalRecord', activeContent);
            this.tags = activeContent.postalCodes;

      } else {
        store.commit('setActiveLocalRecord', {});
      }
    },
    changeLocale(locale) {
      console.log(locale);
      store.commit('setActiveLocale', locale);
      this.initializeProductGroup(true);
    },
    toggleAddLocale() {
      store.commit('showCreateProductGroupLocalRecordModal', true);
    },
    save() {
      const update = this.getActiveProductGroup;
      const contentUpdate = this.getActiveLocalRecord;
      update.content = contentUpdate;

      const postalCodes = [];

    if(this.tags && this.tags.length) {
        for(let i = 0; i < this.tags.length; i++) {
          const tag = this.tags[i];
          if(tag.tiClasses.indexOf('ti-invalid') === -1 ){
              postalCodes.push(tag.text);

          }
      }
    }

      update.content.postalCodes = postalCodes;

      postResource(
        '/v1/productgroups/update',
        `id=${this.getActiveProductGroup._id}&locale=${encodeURIComponent(
          this.getActiveLocale
        )}`,
        update
      )
        .then(res => {
          console.log(res);
          // return  Services.setActiveProduct(productId, this.initializeProduct(true));
          Services.getProductGroups();
        })
        .then(() => {
          this.showSuccessMsg({
            message: `${this.getActiveLocale} product group saved!`
          });
        })
        .catch(error => {
          this.showSuccessMsg({
            message: `${this.getActiveLocale} product group saved!`
          });
        });
    }
  },
  mounted() {
    const productGroupId = this.$route.params.productGroupId;

    if (!productGroupId) {
      this.showErrorMsg({ message: 'No matching product group found' });
      this.$router.push('/product-groups/');
    }

    Services.setActiveProductGroup(productGroupId, this.initializeProductGroup);
    if (!store.getters.getMarkets.length) {
      Services.getMarkets();
    }
  },
  beforeDestroy() {
    Services.clearActiveProductGroup();
    Services.clearActiveRecords();
  }
};
</script>
<style lang="scss" scoped>
.button__submit {
  padding: 8px 32px;
  width: auto;
  margin-left: 25px;
}

.editing__container {
  display: flex;
  padding: 2rem;
  margin-top: 2rem;
  flex-wrap: no-wrap;
  width: 100%;

  .form__control-group {
    margin-bottom: 0.625rem;
  }

  input,
  textarea {
    width: 100%;

    &.title {
      max-width: 630px;
    }
  }

  .image__container,
  .meta__container {
    width: 33.33%;

    .button__action {
      margin: 1rem 0;
    }
  }

  .image__container {
    display: block;

    img {
      margin: auto;
    }
  }

  .content__container {
    width: 100%;
  }

  .content__container,
  .meta__container {
    padding-left: 2.6rem;
  }

  @media all and (max-width: 640px) {
    flex-direction: column;

    .image__container,
    .content__container,
    .meta__container {
      padding-left: 0;
      width: 100%;
    }
  }
}

.form__control-group {
  label {
    display: block;
    margin-bottom: 5px;
  }

  .product-image {
    margin-top: 1.6rem;
    max-width: 630px;
    width: 100%;
  }
}

.media__container,
.product__container {
  padding-left: 4.7rem;
  margin-bottom: 2rem;
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/components/views/ProductGroupEditor.vue